import axios from '@/axios.js'

export default {
    getPhotos: async (appUuid, parameters) => {
        try {
            const response = await axios.editorapi.get(`v4/apps/${appUuid}/photos`, { params: parameters })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    exportPhotos: async (appUuid, parameters) => {
        try {
            const response = await axios.editorapi.get(`v4/apps/${appUuid}/export/photos`, { params: parameters })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
}